import React, { Component } from 'react';
// import Youtube from 'react-youtube'
import './index.scss';

// import play from '../../assets/youtube/play.png'

import Container from '../../../../components/Container'
import Section from '../../../../components/Section'
import Dots from '../Dots'
import JourneyInfo from '../JourneyInfo'

class How extends Component {
  state = {
    visible: false,
    type: 2,
    selected: 1
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const currentScrollPos = window.pageYOffset + (window.innerHeight * 0.9);
    const { journeyInfo1, journeyInfo2, journeyInfo3, journeyInfo4, journeyInfo5 } = this
    let selected = ''

    if (currentScrollPos >= journeyInfo1.offsetTop) selected = 1
    if (currentScrollPos >= journeyInfo2.offsetTop) selected = 2
    if (currentScrollPos >= journeyInfo3.offsetTop) selected = 3
    if (currentScrollPos >= journeyInfo4.offsetTop) selected = 4
    if (currentScrollPos >= journeyInfo5.offsetTop) selected = 5

    if (selected) this.setState({ selected })
  }

  onReady(event) {
    event.target.playVideo()
  }

  render() {
    const { type, selected } = this.state

    const texts = [
      { 1: <p>Para inserir um caso em nossa plataforma, preencha os seus dados e <a href="https://comacordo.com.br/cadastro" target='_blank' rel="noopener noreferrer">crie a sua conta</a>.</p>, 2: <p>Um processo é inserido pelo departamento juridico em nossa plataforma, e você recebe um convite para negociar.</p> },
      { 1: <p>Você será direcionado para um tour pela nossa plataforma, compreendendo todo o processo de negociação.</p>, 2: <p>Ao clicar no botão/link do convite, você será direcionado automaticamente para a plataforma.</p> },
      { 1: <p>Nesse estágio você irá criar o seu primeiro caso. Apenas será possível a inserção de casos ainda não ajuizados.</p>, 2: <p>Para iniciar a negociação, clique no botão "negociar" em nosso chat e inicie a troca de mensagem.</p> },
      { 1: <p>Agora é só aguardar o Com Acordo se comunicar com a empresa ré.</p>, 2: <p>Caso a proposta seja aceita, irá se iniciar o estágio de troca de minutas e envio do protocolo.</p> },
      { 1: <p>Parabéns! Agora você está apto a negociar e inserir novos casos. Esperamos você novamente.</p>, 2: <p>Parabéns! Você fechou o seu primeiro acordo utilizando a plataforma do Com Acordo. Esperamos você novamente.</p> }
    ]

    return (
      <Container id="How">
        <Section
          name="Como funciona?"
          title="Entenda melhor como funciona"
          text="O Com Acordo é uma plataforma de negociação online, exclusiva e gratuita para advogados. A negociação é conduzida diretamente pelas partes através do chat, abrangendo toda a cadeia de tratativas. Entenda melhor abaixo como funciona a plataforma." />
        <div className='module'>
          <span className={type === 2 ? 'module__text module__text--selected' : 'module__text'} onClick={() => this.setState({ type: 2 })}>Módulo Contencioso</span>
          <span className={type === 1 ? 'module__text module__text--selected' : 'module__text'} onClick={() => this.setState({ type: 1 })}>Módulo Pré Contencioso</span>
        </div>
        <div className='journey'>
          <JourneyInfo reference={el => this.journeyInfo1 = el} text={texts[0][type]} number={1} selected={selected} />
          <Dots number={2} selected={selected} />
          <JourneyInfo reference={el => this.journeyInfo2 = el} text={texts[1][type]} number={2} selected={selected} />
          <Dots number={3} selected={selected} />
          <JourneyInfo reference={el => this.journeyInfo3 = el} text={texts[2][type]} number={3} selected={selected} />
          <Dots number={4} selected={selected} />
          <JourneyInfo reference={el => this.journeyInfo4 = el} text={texts[3][type]} number={4} selected={selected} />
          <Dots number={5} selected={selected} />
          <JourneyInfo reference={el => this.journeyInfo5 = el} text={texts[4][type]} number={5} selected={selected} />
        </div>
        {
          // visible ?
          //   <Youtube
          //     className='youtube__video'
          //     videoId='rgVumWYd36w'
          //     onReady={this.onReady}
          //     onEnd={() => this.setState({ visible: false })} />
          //   :
          <div className='youtube__image'>
            {/* Necessity of absolute wrappers to stack */}
            <div className="youtube__wrapper">
              <Container>
                <div className="youtube__background" onClick={() => this.setState({ visible: true })}></div>
              </Container>
            </div>
            {/* Necessity of absolute wrappers to stack */}
            <div className="youtube__wrapper">
              <Container>
                <div className="youtube__content" onClick={() => this.setState({ visible: true })}>
                  <h3>Venha Conosco</h3>
                  <p>Feche um acordo e deixe tudo mais verde!</p>
                  {/*<img src={play} alt="Play" />*/}
                </div>
              </Container>
            </div>
          </div>
        }
      </Container>
    )
  }
}

export default How
